import { AlertOctagon } from "lucide-react";

// Έντονη κόκκινη ένδειξη «ΑΠΑΙΤΕΙΤΑΙ ΑΝΑΧΡΕΩΣΗ» ανά υπόθεση (Πινάκια, Ημερολόγιο Έδρας, Καρτέλα).
// need: {code, reason, judge} | null · onClick → ΑΝΑΧΡΕΩΣΗ της συγκεκριμένης υπόθεσης
export const NeedsReassignmentBadge = ({ need, onClick, caseId, compact = false }) => {
  if (!need) return null;
  const Tag = onClick ? "button" : "span";
  return (
    <Tag type={onClick ? "button" : undefined} onClick={onClick}
         className={`inline-flex items-center gap-1 rounded bg-red-600 text-white font-extrabold tracking-wide px-1.5 py-0.5 leading-none
                     ${compact ? "text-[10px]" : "text-[11px]"} ${onClick ? "hover:bg-red-700 cursor-pointer shadow-sm" : ""}`}
         title={`${need.reason}${onClick ? " — κλικ για ΑΝΑΧΡΕΩΣΗ" : ""}`}
         data-testid={`needs-reassignment-${caseId}`} data-code={need.code}>
      <AlertOctagon className="w-3 h-3 shrink-0" />ΑΠΑΙΤΕΙΤΑΙ ΑΝΑΧΡΕΩΣΗ
    </Tag>
  );
};

// Παράμετροι ReassignDialog για ΜΙΑ υπόθεση: Πολυμελές → μόνο μέλη Σύνθεσης (backend), Μονομελές → προεπιλογή ο Δικαστής Έδρας
export const singleCaseReassignTarget = ({ pinakioLabel, hearingDate, courtType, caseId, benchJudge }) => ({
  pinakioLabel, hearingDate, courtType, caseIds: [caseId],
  presetNewJudgeName: courtType === "Πολυμελές" ? undefined : (benchJudge || undefined),
});

export default NeedsReassignmentBadge;
